import React from "react"
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom"
import { HelmetProvider } from "react-helmet-async"
import { WebTTMI } from "./features/web-ttmi"
import HeThongCuaHang from "./pages/HeThongCuaHang"
import About from "./pages/About"
import Menu from "./pages/Menu"
import Promtion from "./pages/Promtion"
import Contact from "./pages/Contact"
import Policy from "./pages/Policy"
import NotFound from "./pages/NotFound"
import { ROUTES } from "./constants"
import HomePage from "./features/homepage"
import Partner from "./features/partner"
import CuaHang from "./features/store"
import RecruitmentPage from "./features/recruitment"
import RecruitmentDetailPage from "./features/recruitment/RecruitmentDetailPage"
import FloatingWidgets from "./components/FloatingWidgets"

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route
            path={ROUTES.HOME}
            element={
              <WebTTMI>
                <HomePage />
              </WebTTMI>
            }
          />
          <Route path={ROUTES.HETHONGCUAHANG} element={<HeThongCuaHang />} />
          <Route
            path={ROUTES.STORE_LOCATOR}
            element={
              <WebTTMI>
                <CuaHang />
              </WebTTMI>
            }
          />
          <Route
            path={ROUTES.ABOUT}
            element={
              <WebTTMI>
                <About />
              </WebTTMI>
            }
          />
          <Route
            path={ROUTES.MENU}
            element={
              <WebTTMI>
                <Menu />
              </WebTTMI>
            }
          />
          <Route path={ROUTES.PROMOTION} element={<Promtion />} />
          <Route
            path={ROUTES.PARTNER}
            element={
              <WebTTMI>
                <Partner />
              </WebTTMI>
            }
          />
          <Route
            path={ROUTES.CONTACT}
            element={
              <WebTTMI>
                <Contact />
              </WebTTMI>
            }
          />
          <Route
            path={ROUTES.POLICY}
            element={
              <WebTTMI>
                <Policy />
              </WebTTMI>
            }
          />
          <Route
            path={ROUTES.RECRUITMENT}
            element={
              <WebTTMI>
                <RecruitmentPage />
              </WebTTMI>
            }
          />
          <Route
            path={ROUTES.RECRUITMENT_DETAIL}
            element={
              <WebTTMI>
                <RecruitmentDetailPage />
              </WebTTMI>
            }
          />
          <Route
            path={ROUTES.NOT_FOUND}
            element={
              <WebTTMI>
                <NotFound />
              </WebTTMI>
            }
          />
        </Routes>
        <FloatingWidgets />
      </Router>
    </HelmetProvider>
  )
}

export default App
